import React, { useState } from "react";
import { bool, func } from "prop-types";

import * as S from "./styled";

const SaveButtonHeart = ({ isSaved, onClickSave }) => {
  const [behavior, setBehavior] = useState("");

  return (
    <S.SaveButtonWrapper>
      <S.SaveButton
        aria-label={`${isSaved ? "unsave" : "save"} listing`}
        behavior={behavior}
        isSaved={isSaved}
        onClick={() => {
          setBehavior(`${isSaved ? "toBeUnsaved" : "toBeSaved"}`);
          onClickSave();
        }}
      >
        <S.ListingSaveLine />
        <S.ListingSaveLine />
        <S.ListingSaveLine />
        <S.ListingSaveLine />
      </S.SaveButton>
    </S.SaveButtonWrapper>
  );
};

SaveButtonHeart.propTypes = {
  isSaved: bool.isRequired,
  onClickSave: func.isRequired
};

export default SaveButtonHeart;
